import { render, staticRenderFns } from "./proyecto-el.vue?vue&type=template&id=3b5f2eb4"
import script from "./proyecto-el.vue?vue&type=script&lang=js"
export * from "./proyecto-el.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports